import * as fromAccountActions from '../actions';
import { AccountInvoice } from '../../model/account-invoice';
import { Entity } from './../../../shared/interfaces/entity';

export interface AccountInvoicesState {
  entities: Entity<AccountInvoice>;
  loaded: boolean;
  loading: boolean;
}

export const accountInvoicesInitialState: AccountInvoicesState = {
  entities: [],
  loaded: false,
  loading: false
};

export function reducer(
  state: AccountInvoicesState = accountInvoicesInitialState,
  action: fromAccountActions.AccountInvoicesActions
): AccountInvoicesState {
  switch (action.type) {
    case fromAccountActions.LOAD_ACCOUNT_INVOICES: {
      return {
        ...state,
        loaded: false,
        loading: true
      };
    }

    case fromAccountActions.LOAD_ACCOUNT_INVOICES_SUCCESS: {
      const invoices: Array<AccountInvoice> = action.payload;
      const entities: Entity<AccountInvoice> = invoices.reduce(
        (
          accountInvoices: Entity<AccountInvoice>,
          accountInvoice: AccountInvoice
        ) => {
          return {
            ...accountInvoices,
            [accountInvoice.id]: accountInvoice
          };
        },
        {
          ...state.entities
        }
      );

      return {
        ...state,
        loading: false,
        loaded: true,
        entities
      };
    }

    case fromAccountActions.LOAD_ACCOUNT_INVOICES_FAIL: {
      console.error('failed', action.payload);
      return state;
    }
  }

  return state;
}

export const getAccountInvoicesEntities: any = (
  state: AccountInvoicesState
): Entity<AccountInvoice> => state.entities;
export const getAccountInvoicesLoaded: any = (
  state: AccountInvoicesState
): boolean => state.loaded;
export const getAccountInvoicesLoading: any = (
  state: AccountInvoicesState
): boolean => state.loading;
